import { IInterest } from "api/types";

export const getSelectedSegmentationDetailIds = (
  segmentationDetail: IInterest[]
) => segmentationDetail.filter(s => s.checked).map(s => s.id);



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Onboarding.utils.ts